__turbopack_context__.v({
  "badge": "TopicsCovered-module__RGqERa__badge",
  "badgeLabel": "TopicsCovered-module__RGqERa__badgeLabel",
});
